import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { ActionErrorDescription } from 'src/app/store/notification/notification-toastr/types/actionErrorDescription.decorator';
import { LongRunningAction } from 'src/app/store/server-communication/running-actions/types/longRunningAction.decorator';
import { IBrickInstanceTargetingAction } from 'src/app/store/utility/IBrickInstanceTargetingAction';
import { DirectoryEntryRemoteDto, DirectoryRestrictionFilterRemoteDto, DirectorySearchFilterRemoteDto, PagingInfoRemoteDto } from 'src/generated/swagger';

export class DirectoryValuesLoaded implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Data Behaviour] Directory Values Loaded';

   constructor(public brickInstanceId: string, public resultEntries: DirectoryEntryRemoteDto[]) {}
}
export class SetLoadedDirectoryValues implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Data Behaviour] Set Loaded Directory Values';

   constructor(public brickInstanceId: string, public loadedDirectoryValues: DirectoryEntryRemoteDto[]) {}
}

export class SetSearchExecuted implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Data Behaviour] Set Was Search Executed';

   constructor(public brickInstanceId: string, public wasSearchExecuted: boolean) {}
}

export class SetAllDataLoaded implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Data Behaviour] Set All Data Loaded';

   constructor(public brickInstanceId: string, public allDataLoaded: boolean) {}
}

export class SetSearchRelatedData implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Data Behaviour] Set Search Related Data';

   constructor(
      public brickInstanceId: string,
      public loadedDirectoryValues: DirectoryEntryRemoteDto[],
      public wasSearchExecuted: boolean,
      public allDataLoaded: boolean
   ) {}
}

export class DirectoryValuesUpdateEntry {
   public static readonly type = '[Directory Browser Data Behaviour] Update Directory Entry In Loaded Values';

   constructor(public brickInstanceId: string, public id: number, public entry: DirectoryEntryRemoteDto) {}
}

export class DirectoryValuesRemoveEntry {
   public static readonly type = '[Directory Browser Data Behaviour] Remove Directory Entry From Loaded Values';

   constructor(public brickInstanceId: string, public id: number) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.DIRECTORY_SEARCH)
@ActionErrorDescription({
   titleTranslationKey: 'brick.brick_definitions.directory_browser.error_handling.loading_failed.title',
   messageTranslationKey: 'brick.brick_definitions.directory_browser.error_handling.loading_failed.message',
})
export class QueryDirectory implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Data Behaviour] Query Directory';

   constructor(
      public brickInstanceId: string,
      public searchFilter: Array<DirectorySearchFilterRemoteDto>,
      public pagingInfo: PagingInfoRemoteDto,
      public sortByColumnKey: string,
      public sortByDescending: boolean,
      public searchableColumns: Array<string>,
      public limitToDirectoryEntries: Array<DirectoryRestrictionFilterRemoteDto>,
      public restrictToSubscriberId?: number,
      public matchingPercentage?: number
   ) {}
}
